import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import { DuLieuHeThong } from 'api';
import {validatable} from 'components/utils';

class DropDownChonQuanHuyen extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      data: [],
      allData: [],
      mounted:  false
    }
  }
  onChange(e) {
    this.props.onChange(e);
  }

  componentDidMount() {
    this.setState({mounted:  true});
    if (this.props.thanhPhoID)
      this.loadData(this.props.thanhPhoID);
  }

  componentWillUnmount() {
    this.setState({mounted:  false});
  }

  loadData(thanhphoID) {
    DuLieuHeThong.actions.getCapQuanHuyen.request({id: thanhphoID}).then(res => {
      if (this.state.mounted) {
        if (typeof res.data._embedded != "undefined") {
          // TODO: Use Redux
          this.setState({
            data: res.data._embedded.donViHanhChinhs
          })
        } else {
          this.setState({
            data: []
          });
        }
      }
    }).catch(err => {})
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.thanhPhoID != nextProps.thanhPhoID) {
      if (nextProps.thanhPhoID) {
        if (typeof this.state.allData[nextProps.thanhPhoID] != "undefined") {
          this.setState({
            data: this.props.data[nextProps.thanhPhoID]
          });
        } else {
          this.loadData(nextProps.thanhPhoID);
        }
      } else {
        this.setState({
          data: []
        });
      }
    }
  }

  render() {
    return (
      <DropDown disabled={this.props.disabled} className={this.props.className} selectedValue={this.props.selectedValue} label="Quận/Huyện"
      options={ this.state.data } keyName='donViHanhChinhId' valueName='ten' onChange={ this.onChange.bind(this) }
      placeholder={ this.props.placeholder } require={this.props.require} bindValidator={this} channel="danhMuc" name="quanHuyen"/>
    )
  }
}

DropDownChonQuanHuyen.defaultProps = {
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  className: 'col-input',
  require: false,
  isValid: false,
  disabled: false
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.capQuanHuyen
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonQuanHuyen));



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-quanhuyen.jsx